/**
 * Whether an account matches a client-side account search: its name or its
 * number contains the term, case-insensitively. A blank term matches
 * everything. Name and number are matched separately, as the connection
 * accounts RPC does, so a term spanning both never matches.
 *
 * @param account - The account's name and number
 * @param term - What the user typed
 */
export function matchesAccountSearch(
  account: { name: string; account_number: string | null },
  term: string,
): boolean {
  const needle = term.trim().toLowerCase()
  if (!needle) return true
  return (
    account.name.toLowerCase().includes(needle) ||
    (account.account_number ?? '').toLowerCase().includes(needle)
  )
}
